// prettier-ignore
export const ActionTypes = {
  SHOW_EDIT_DEVIATE_COMMENT: 'harami/templates/SHOW_EDIT_DEVIATE_COMMENT',
  CLOSE_EDIT_DEVIATE_COMMENT: 'harami/templates/CLOSE_EDIT_DEVIATE_COMMENT',
} as const satisfies { [k: string]: string}
